import { CopyAll } from "@mui/icons-material";

const Tooltip = ({
    children,
    value,
    pressedValue,
    className,
}: {
    children: React.ReactNode;
    value: string;
    pressedValue?: string | null;
    className?: string;
}) => {
    return (
        <div className={"tooltip__container " + className}>
            {children}
            <span className="tooltip__value">{pressedValue || value}</span>
        </div>
    );
};

export default Tooltip;
